import {Component, Input, OnInit} from '@angular/core';
import {RegisterForm} from '@app/sign-in/register/@form/register-form';

@Component({
  selector: 'app-surname-field[registerForm][showValidation]',
  templateUrl: './surname-field.component.html',
  styleUrls: ['./surname-field.component.scss']
})
export class SurnameFieldComponent implements OnInit {
  @Input() registerForm!: RegisterForm;
  @Input() showValidation!: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  isInvalid(): boolean {
    return this.showValidation && this.registerForm.controls.surname.invalid;
  }

}
